import { useEffect } from 'react';

import { ErrorCard as BaseErrorCard } from '@percent/domain/verifications';
import { useHostedValidationsFormAnalytics } from '@percent/hosted-validation-form/hooks/useHostedValidationsFormAnalytics/useHostedValidationsFormAnalytics';
import { ErrorCardProps } from './ErrorCard.types';

export const ErrorCard = ({ title, subtitle, variant, children, sendAnalytics = true }: ErrorCardProps) => {
  const { page, analyticsLoaded } = useHostedValidationsFormAnalytics();

  useEffect(() => {
    if (analyticsLoaded && sendAnalytics) {
      page(variant, {
        category: 'Error',
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [variant, analyticsLoaded]);

  return <BaseErrorCard title={title} subtitle={subtitle} variant={variant} children={children} />;
};
